<button
  type="button"
  class="switch"
  role="switch"
  [attr.aria-checked]="checked"
  [attr.aria-disabled]="disabled ? true : null"
  [attr.aria-label]="ariaLabel || null"
  [disabled]="disabled"
  [ngClass]="{ on: checked, off: !checked }"
  (keydown)="onKeydown($event)"
  (click)="toggle()">
  <span class="thumb" aria-hidden="true"></span>
</button>
